export default __webpack_public_path__ + "static/media/customerfocus.1a443b77.svg";